import { CircleDashed } from "lucide-react";

interface LoadingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  children: React.ReactNode;
}

export function LoadingButton({
  isLoading = false,
  children,
  disabled,
  className = "",
  ...props
}: LoadingButtonProps) {
  return (
    <button
      disabled={disabled || isLoading}
      className={[
        "h-10 min-w-[160px] overflow-hidden rounded-md px-6 text-sm font-medium transition-colors",
        "bg-primary hover:bg-primary/90 text-primary-foreground",
        disabled || isLoading ? "pointer-events-none opacity-50" : "",
        className,
      ].join(" ")}
      {...props}
    >
      <div className="flex items-center justify-center gap-1">
        {isLoading ? (
          <>
            <CircleDashed className="h-4 w-4 animate-spin" />
            Loading...
          </>
        ) : (
          children
        )}
      </div>
    </button>
  );
}

// For backward compatibility
export const StatusButton = LoadingButton;
